import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import AddIcon from "@mui/icons-material/Add";

const style = {
    position: 'absolute' as 'absolute',
    top: '50px',
    left: '50%',
    width: '100%',
    maxWidth: '90%',
    transform: 'translate(-50%, 0px)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    maxHeight: 'calc(100vh - 100px)',
    overflow: 'auto',
    outline: 'none'
};

export default function BasicModal(props:any) {

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const {title, width} = props || {};

    return (
        <>
            <div onClick={handleOpen} style={{width: width || 'auto', justifyContent: 'flex-end'}}>
                <AddIcon />
                <span>
                {title || 'Open Modal'}
                </span></div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    {props.children}
                </Box>
            </Modal>
        </>
    );
}